import { render, staticRenderFns } from "./retiroEquipo.vue?vue&type=template&id=c6bf50de&"
import script from "./retiroEquipo.vue?vue&type=script&lang=ts&"
export * from "./retiroEquipo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c6bf50de', component.options)
    } else {
      api.reload('c6bf50de', component.options)
    }
    module.hot.accept("./retiroEquipo.vue?vue&type=template&id=c6bf50de&", function () {
      api.rerender('c6bf50de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/CambiosServicio/retiroEquipo.vue"
export default component.exports